export const getRequestError = (error: any, fallback: string): string => {
  const message = error?.response?.data?.error ?? error?.response?.data?.message;
  if (Array.isArray(message)) {
    const messages = message.filter((value): value is string => typeof value === "string");
    return messages.join(" ") || fallback;
  }
  return typeof message === "string" && message.trim() ? message : fallback;
};
